export const ALL = 'ALL';
export const APP_JSON = 'application/json';
export const BUTTON_ACTION_PAY = 'PAY';
export const BUTTON_ACTION_CONTINUE = 'CONTINUE';
export const DATA_DELIM = '--';
export const DFP_SESSION_ID = 'dfpSessionId';
export const FORM_URL_ENCODED = 'application/x-www-form-urlencoded';
export const FULL = 'FULL';
export const NONE = 'NONE';
export const POSTAL_COUNTRY = 'POSTAL_COUNTRY';
export const SCRIPT_LOAD_TIMEOUT = 7000;
export const SRC_PROFILE_TIMEOUT = 10000;
export const VISA_SRCI_IFRAME_ID = 'vcop-src-frame';
export const X_CORRELATION_ID = 'X-CORRELATION-ID';
export const X_THMID = 'X-THMID';

export const billingPreferenceMap = {
  CNTRY: POSTAL_COUNTRY,
  FULL,
  POSTALCNTRY: POSTAL_COUNTRY
};

export const maBillingPreferenceMap = {
  CNTRY: POSTAL_COUNTRY,
  FULL,
  POSTALCNTRY: POSTAL_COUNTRY
};

export const apiMethodnames = {
  CHECKOUT: 'checkout',
  GET_SRC_PROFILE: 'getSrcProfile',
  IDENTITY_LOOKUP: 'identityLookup',
  INIT: 'init',
  IS_RECOGNIZED: 'isRecognized',
  UNBIND_APP_INSTANCE: 'unbindAppInstance'
  //Please add remaining method names here
};

export const apiErrors = {
  NO_INSTANCE: 'NO_INSTANCE',
  NO_METHOD: 'NO_METHOD',
  REJECT: 'Promise Rejected',
  TIME_OUT: 'TIME_OUT'
};

export const checkoutFlow = {
  RXO: 'RXO',
  SRC: 'SRC',
  VDCP: 'VDCP'
};

export const idLookupMACustom = {
  consumerIdentity: {
    identityProvider: 'SRC',
    identityType: 'EMAIL_ADDRESS'
  }
};
//TODO => Remove hardcoded values once we get accurate data obj
//MA needs custom Data
export const maCustomInitData = {
  dpaTransactionOptions: {
    //Mandate
    dpaAcceptedShippingCountries: [],
    dpaShippingPreference: 'FULL',
    paymentOptions: {
      dynamicDataType: 'DYNAMIC_CARD_SECURITY_CODE' //Mandate
    },
    transactionAmount: {
      transactionAmount: '99.95',
      transactionCurrencyCode: 'USD'
    }
  },
  srcInitiatorId: '7b7513c0-4691-11e9-b210-d663bd873d93',
  srciDpaId: '7b7513c0-4691-11e9-b210-d663bd873d93', //Mandate
  srciTransactionId: 'fa01331c-aa5a-408b-8f8d-801b05efc681'
};

export const maCustomToken = {
  idTokens: []
};

// F11669 - usernameType values, used as param to Visa lookupUserName api
export const USERNAME_TYPE = {
  EMAIL: 'EMAIL',
  REMEMBER_ME: 'REMEMBER_ME'
};
